var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHelp = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#737373",
    d: "M12 5c3.864 0 7 3.136 7 7s-3.136 7-7 7-7-3.136-7-7 3.136-7 7-7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.39 15.714a.69.69 0 0 1-.507.207.7.7 0 0 1-.507-.207.69.69 0 0 1-.207-.506q0-.3.207-.507a.69.69 0 0 1 .506-.207q.3 0 .507.207a.69.69 0 0 1 .207.506.7.7 0 0 1-.207.507Zm.396-6.415a1.24 1.24 0 0 0-.838-.305q-.35 0-.652.167a1.65 1.65 0 0 0-.514.443.6.6 0 0 1-.344.23.54.54 0 0 1-.393-.061.4.4 0 0 1-.185-.273.48.48 0 0 1 .061-.343 2 2 0 0 1 .862-.807 2.6 2.6 0 0 1 1.178-.277q.875 0 1.53.535.656.536.656 1.367 0 .542-.286.983a4.7 4.7 0 0 1-.668.813q-.266.255-.494.536a1.44 1.44 0 0 0-.298.643.6.6 0 0 1-.18.33.48.48 0 0 1-.341.135.47.47 0 0 1-.33-.13.4.4 0 0 1-.134-.32q.02-.498.31-.904.29-.405.671-.744a4 4 0 0 0 .517-.566q.226-.305.226-.69a.97.97 0 0 0-.354-.762"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHelp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/help.3a6e0aa2.svg";